import { render } from "./front-imagen-perfil.vue?vue&type=template&id=3780257b"
import script from "./front-imagen-perfil.vue?vue&type=script&lang=js"
export * from "./front-imagen-perfil.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__